import { L, LNotification } from "@lib/abpUtility"
import { notifyError, notifySuccess } from "@lib/helper"
import {
  FloorStaffModel,
} from "@models/floorStaff/floorStaffModel"
import { PagedResultDto } from "@services/dto/pagedResultDto"
import http from "@services/httpService"

class FloorStaffService {
  public async create(body: any) {
    const res = await http.post("api/services/app/Employees/Create", body)
    notifySuccess(L("SUCCESSFULLY"), L("CREATE_SUCCESSFULLY"))
    return res.data.result
  }

  public async update(body: any) {
    const res = await http.put("api/services/app/Employees/Update", body)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async activateOrDeactivate(id: number, active: boolean) {
    const res = await http.post(
      "api/services/app/Employees/Active?isActive=" + active,
      { id: id } 
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }

  public async bulkActive(id: number[]) {
    const res = await http.post("api/services/app/Customers/BulkActive", id)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }

  public async get(id: number): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get("api/services/app/Employees/Get", {
      params: { id },
    })
    return FloorStaffModel.assign(res.data.result)
  }

  public async getAll(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/Employees/GetAll", { params })
    return res.data.result
  }

  public async getExistPhone(phone: string): Promise<any> {
    const res = await http.get("api/services/app/Employees/GetAll", {
      params: { keyword: phone },
    })
    return FloorStaffModel.assign(res.data.result)
  }

  public async getExistUsername(username: string): Promise<any> {
    const res = await http.get("api/services/app/Employees/GetAll", {
      params: { keyword: username },
    })
    return FloorStaffModel.assign(res.data.result)
  }

  public async getExistEmail(email: string): Promise<any> {
    const res = await http.get("api/services/app/Employees/GetAll", {
      params: { keyword: email },
    })
    return FloorStaffModel.assign(res.data.result)
  }

  public async getListFloor(): Promise<any[]> {
    const res = await http.get(
      "api/services/app/AgencyMasters/GetListAgencyMaster"
    )
    return res.data.result
  }

  public async getAllOpportunityById(
    params: any
  ): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/Inquiry/GetAll", {
      params,
    })
    return res.data.result
  }

  public async getAllCustomerById(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/Customers/GetAll", {
      params,
    })
    return res.data.result
  }

  public async getAuditLogs(id: number): Promise<any> {
    const res = await http.get("api/services/app/Employees/GetAuditLogs", {
      params: { id },
    })
    return res.data.result
  }
}

export default new FloorStaffService()
